import { render, staticRenderFns } from "./HomeSliderContent.vue?vue&type=template&id=2140b89d&scoped=true&"
import script from "./HomeSliderContent.vue?vue&type=script&lang=js&"
export * from "./HomeSliderContent.vue?vue&type=script&lang=js&"
import style0 from "./HomeSliderContent.vue?vue&type=style&index=0&id=2140b89d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2140b89d",
  null
  
)

export default component.exports